// src/components/QuestionTimer.js
import React from 'react';
import './QuestionTimer.css';

const TOTAL_EXAM_SECONDS = 7200; // prova de 2 horas

const QuestionTimer = ({ maxTime }) => {
  const formatTime = (totalSeconds) => {
    const safeSeconds = Math.max(0, totalSeconds || 0);
    const hours = Math.floor(safeSeconds / 3600);
    const minutes = Math.floor((safeSeconds % 3600) / 60);
    const seconds = safeSeconds % 60;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  const progressPercentage = Math.min(100, ((maxTime || 0) / TOTAL_EXAM_SECONDS) * 100);
  const isWarning = progressPercentage <= 25;

  return (
    <div className={`timer-container ${isWarning ? 'warning' : ''}`}>
      <span className="timer-icon">⏱</span>
      <div className="timer-body">
        <span className={`timer-display ${isWarning ? 'warning' : ''}`}>{formatTime(maxTime)}</span>
        <div className="progress-bar">
          <div
            className={`progress ${isWarning ? 'warning' : ''}`}
            style={{ width: `${progressPercentage}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default QuestionTimer;